import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { BsLinkedin, BsYoutube, BsInstagram } from "react-icons/bs";
import './Footer.css';
const IMG_UNION_EUROPEA_URL = new URL('../../img/footer/union_europea.png', import.meta.url).href;
const IMG_XUNTA_GALICIA_URL = new URL('../../img/footer/xunta_galicia_completo.png', import.meta.url).href;

const Footer = () => {
    return (
        <Navbar bg="light" expand="lg" fixed="bottom" className="footer-navbar">
            <Container className="footer-container">
                {/* Social Icons - Left */}
                <div className="footer-social">
                    <a href={"https://www.linkedin.com/company/goyanes-somoza/"} target="_blank" rel="noopener noreferrer"><BsLinkedin /></a>
                    &nbsp;
                    <a href={"https://www.instagram.com/goyanessomoza/"} target="_blank" rel="noopener noreferrer"><BsInstagram /></a>
                    &nbsp;
                    <a href={"https://www.youtube.com/@goyanessomoza2983/"} target="_blank" rel="noopener noreferrer"><BsYoutube /></a>
                </div>

                {/* Copyright - Center */}
                <div className='footer-copyright'>
                    &copy; Goyanes Somoza SL
                </div>

                {/* Logos - Right */}
                <div className="footer-logos">
                    <a href="/xunta-galicia">
                        <img
                            src={IMG_XUNTA_GALICIA_URL}
                            alt={"Logo Xunta de Galicia"}
                            width="140"
                            height="40">
                        </img>
                    </a>
                    <a href="/union-europea">
                        <img
                            src={IMG_UNION_EUROPEA_URL}
                            alt={"Logo UE"}
                            width="80"
                            height="69">
                        </img>
                    </a>
                </div>
            </Container>
        </Navbar>
    );
}

export default Footer;